import React from "react";
import Ripples from 'react-ripples';
// reactstrap components
import { Button, Row } from "reactstrap";

import actions from '../../actions/cart'
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { IonIcon } from "@ionic/react";
import { trash, trashBin, trashOutline, trashSharp } from "ionicons/icons";

interface PackCounterProps {
    product: any,
    establishment_id: number,
    hide_addon?: boolean,
}

const PackBoxCounter: React.FC<PackCounterProps> = ({ product, establishment_id, hide_addon = false }) => {

    const { id: product_id, price, name, is_veg, addons_product } = product
    //Selectors
    const getProductState = store => store.cart.products ?? []

    const findProductById = (store, id) => {
        // const index = getProductState(store).findIndex((product: any) => product.id === id)
        // const index = getProductState(store).reduce((result, product) => {
        //     if (product.id == id)
        //         result.push(product.id);
        //     return result
        // }, [])
        // let index: any = []
        // getProductState(store).map((product: any) => {
        //     if (product.id == id)
        //         index.push(product.id);
        // })
        const index = getProductState(store).map((product, index) => product.id === id ? index : '').filter(String);
        const findIndex = getProductState(store)[index[0]]
        return  (index.length > 0 && findIndex) ? findIndex.count * index.length : 0
    }

    //Redux Hooks
    const count = useSelector((state: RootStateOrAny) => findProductById(state, product_id));
    const dispatch = useDispatch();

    const increment = () => {
        if (hide_addon == false && addons_product.length > 0) {
            dispatch(actions.addons_show({ product_id, name, is_veg, price, establishment_id, addons_product }))
        } else {
            const amount = isNaN(price) ? parseFloat(price.substr(1)) : price
            dispatch(actions.increment({ product_id, name, is_veg, amount, establishment_id }))
        }
    }

    const decrement = () => {
        if (count > 0)
            dispatch(actions.decrement({ product_id, establishment_id }))
    }

    return (
        <>
            {/* <Row className="pack-box m-0">
                <Ripples className="col-4 p-0">
                    <Button className="pack-btn shadow-none m-0 px-0" onClick={decrement}></Button>
                </Ripples>
                <small className="pack-count col-4 p-0">{count}</small>
                {(hide_addon == false || (addons_product && addons_product.length < 1)) && (
                    <Ripples className="col-4 p-0">
                        <Button className="pack-btn-plus alt shadow-none m-0 px-2" onClick={increment}></Button>
                    </Ripples>
                )}
            </Row>
            {(hide_addon == false && addons_product && addons_product.length > 0) && (
                <Row className="m-0 mt-1">
                    <small className="w-100 p-0 text-warning text-center">Addons</small>
                </Row>
            )} */}

            {(hide_addon == false || (addons_product && addons_product.length < 1)) ? (
                <>
                    <Row className="pack-box m-0">
                        <Ripples className="col-4 p-0">
                            <Button className="pack-btn shadow-none m-0 px-0" onClick={decrement}></Button>
                        </Ripples>
                        <small className="pack-count col-4 p-0">{count}</small>

                        <Ripples className="col-4 p-0">
                            <Button className="pack-btn-plus alt shadow-none m-0 px-2" onClick={increment}></Button>
                        </Ripples>
                    </Row>
                    {(hide_addon == false && addons_product && addons_product.length > 0) && (
                        <Row className="m-0 mt-1">
                            <small className="w-100 p-0 text-warning text-center">Adicional</small>
                        </Row>
                    )}
                </>
            ) : (
                    <h4 onClick={decrement}><IonIcon icon={trashOutline} className="text-muted mr-1 align-text-top" /></h4>
                )}
        </>
    )
}

export default PackBoxCounter;